// ❌ XCircleIcon.tsx
const XCircleIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,24C5.383,24,0,18.617,0,12S5.383,0,12,0s12,5.383,12,12-5.383,12-12,12Zm0-22C6.486,2,2,6.486,2,12s4.486,10,10,10,10-4.486,10-10S17.514,2,12,2Zm4.707,13.293-2.293-2.293,2.293-2.293a1,1,0,0,0-1.414-1.414L12,11.586,9.707,9.293A1,1,0,0,0,8.293,10.707l2.293,2.293L8.293,15.293a1,1,0,1,0,1.414,1.414L12,14.414l2.293,2.293a1,1,0,0,0,1.414-1.414Z"/>
  </svg>
);

export default XCircleIcon;
